export const capitalizeFirstLetter = (text: string) =>
  text.charAt(0).toUpperCase() + text.split('.')[0].slice(1);
